import { Risk, RiskLevel, Risks } from 'types/suncorpRisks';

const HIGHER_ORDER = ['bushfire', 'cyclone', 'flood', 'storm'];
const LOWER_ORDER = ['storm', 'flood', 'bushfire', 'cyclone'];

/*  Rules
  1. Sort risks by risk level, high > medium > low

  2. If multiple perils are high or medium choose using HIGHER_ORDER

  3. removed

  4. Pick from remaining lower risks using LOWER_ORDER
*/

export const getPrioritizedRisks = (data: Risks | null): Array<Risk> => {
  // Map data to normalized array
  const risks: Risk[] = Object.keys(data || {}).map(key => ({
    peril: key.toLowerCase() as keyof Risks,
    riskLevel: data?.[key as keyof Risks]?.toLowerCase() as RiskLevel,
  }));

  // Rule 1
  risks.sort((a, b) => {
    const riskLevelPriority: Record<RiskLevel, number> = {
      high: 3,
      medium: 2,
      low: 1,
    };
    return riskLevelPriority[b.riskLevel] - riskLevelPriority[a.riskLevel];
  });

  const highRisks = risks.filter(risk => risk.riskLevel === 'high');
  const mediumRisks = risks.filter(risk => risk.riskLevel === 'medium');
  const lowRisks = risks.filter(risk => risk.riskLevel === 'low');

  let selectedRisks: Risk[] = [];

  // Rule 2, fill with high
  if (highRisks.length > 0) {
    for (const peril of HIGHER_ORDER) {
      const risk = highRisks.find(risk => risk.peril === peril);
      if (risk) selectedRisks.push(risk);
      if (selectedRisks.length >= 4) break;
    }
  }

  // Rule 2, Fill with medium
  if (selectedRisks.length < 4 && mediumRisks.length > 0) {
    for (const peril of HIGHER_ORDER) {
      const risk = mediumRisks.find(risk => risk.peril === peril);
      if (risk) selectedRisks.push(risk);
      if (selectedRisks.length >= 4) break;
    }
  }

  // Rule 4, fill with low
  if (selectedRisks.length < 4) {
    for (const peril of LOWER_ORDER) {
      const risk = lowRisks.find(risk => risk.peril === peril);
      if (risk) selectedRisks.push(risk);
      if (selectedRisks.length >= 4) break;
    }
  }

  // If still less than 4 risks are selected, pick anything
  if (selectedRisks.length < 4) {
    const remainingRisks = risks.filter(risk => !selectedRisks.includes(risk));
    selectedRisks = [...selectedRisks, ...remainingRisks]
      .filter(r => !!r.peril && !!r.riskLevel)
      .slice(0, 4);
  }

  return selectedRisks;
};
